<bx-card class="h-full">
  <bx-card-header
    [title]="titleTemplate"
    [supportingTitle]="'product-view.property-overview.supportingTitle' | translate"
    [divider]="false"
  ></bx-card-header>

  <!-- w-full because bx-card centres its children; px-3xl is the card header's own inset, so the bar lines up with the title. -->
  <bxi-product-filter class="mt-2xl px-3xl w-full" (selectionChange)="handleProductsChange($event)"></bxi-product-filter>

  <!-- min-h-0 lets the grid shrink inside the card's flex column; without it the default min-height:auto
       keeps it at full row height and pushes the card past the viewport. -->
  <ag-grid-angular
    class="mt-2xl min-h-0 w-full flex-1"
    rowModelType="serverSide"
    [serverSideDatasource]="datasource"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [getRowId]="getRowId"
    [masterDetail]="true"
    [isRowMaster]="isRowMaster"
    [detailCellRenderer]="detailRenderer"
    [detailRowAutoHeight]="true"
    [theme]="dittoGridService.bxGridTheme"
    [localeText]="locale"
    [pagination]="true"
    [paginationPageSize]="pageSize"
    [cacheBlockSize]="pageSize"
    [paginationPageSizeSelector]="false"
    [activeOverlay]="activeOverlay()"
    [activeOverlayParams]="overlayInputs()"
    (gridReady)="handleGridReady($event)"
  />
</bx-card>

<ng-template #titleTemplate>
  {{ 'product-view.property-overview.title' | translate }}
  @if (countLabel(); as countLabel) {
    <bx-badge class="ml-md" type="badge-color" color="gray" size="sm" [label]="countLabel"></bx-badge>
  }
</ng-template>
